import { useState, useCallback } from 'react';

interface FocusedCell {
  rowId: string | number;
  columnId: string;
}

export const useTableFocus = () => {
  const [focusedCell, setFocusedCell] = useState<FocusedCell | null>(null);

  const handleCellFocus = useCallback((rowId: string | number, columnId: string) => {
    setFocusedCell({ rowId, columnId });
  }, []);

  const handleCellBlur = useCallback(() => {
    setFocusedCell(null);
  }, []);

  const isCellFocused = useCallback(
    (rowId: string | number, columnId: string) => {
      if (!focusedCell) return false;
      return focusedCell.rowId === rowId && focusedCell.columnId === columnId;
    },
    [focusedCell],
  );

  return {
    focusedCell,
    handleCellFocus,
    handleCellBlur,
    isCellFocused,
  };
};
